/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropruleneedslink3Inputs */

const en_dropruleneedslink3 = /** @type {(inputs: Dropruleneedslink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link an event or location above to use this rule.`)
};

const de_dropruleneedslink3 = /** @type {(inputs: Dropruleneedslink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verknüpfe oben ein Event oder einen Ort, um diese Regel zu nutzen.`)
};

/**
* | output |
* | --- |
* | "Link an event or location above to use this rule." |
*
* @param {Dropruleneedslink3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropruleneedslink3 = /** @type {((inputs?: Dropruleneedslink3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropruleneedslink3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropruleneedslink3(inputs)
	return de_dropruleneedslink3(inputs)
});
export { dropruleneedslink3 as "dropRuleNeedsLink" }